import { required } from 'vuelidate/lib/validators'

export default (value) => {
  return !required(value) || value.toLowerCase() !== value
}
